function scaleTextBubble() {

	if(jQuery('#text-bubble-scale').length > 0) {
		var height_wrapper = jQuery('#text-bubble-wrapper').height();
		var new_height_bubble = height_wrapper-80;
		var scale_ratio = new_height_bubble/450;

		jQuery('#text-bubble-scale').css('transform', 'scale('+scale_ratio+')');

	}

}

jQuery(document).ready(function() {
	scaleTextBubble();

	jQuery(window).resize(function(event) {
		scaleTextBubble();
	});


}); 